import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MainFacade } from 'src/app/pages/main.facade';

@Component({
  selector: 'app-mypacks',
  templateUrl: './mypacks.component.html',
  styleUrls: ['./mypacks.component.scss']
})
export class MypacksComponent implements OnInit, OnDestroy {
  public loading$: Observable<any>|undefined;
  public packs$: Observable<any>|undefined;
  public cards$: Observable<any>|undefined;
  public opened$: Observable<any>|undefined;
  public user$: Observable<any>|undefined;
  public selectPack$: Observable<any>|undefined;
  private destroy$ = new Subject();
  showOpen:boolean=false;
  allowVid:boolean=true;
  user:any;
  selected:any='';
  isLoading:boolean=false;
  allowImg:boolean=false;
  selectPack:any='';
  packs:any[]=[];
  constructor(private mainfacade:MainFacade) { }

  ngOnInit(): void {
    this.setObservables();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  setObservables() {
    this.loading$ = this.mainfacade.loading$;
    this.user$ = this.mainfacade.user$;
    this.selectPack$ = this.mainfacade.selectPack$;
    this.packs$ = this.mainfacade.packs$;
    this.cards$ = this.mainfacade.cards$;
    this.opened$ = this.mainfacade.opened$;
    this.user$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){
        this.user = message;
      }
    });

    this.selectPack$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){
        this.selectPack= message;
      }
    });

    this.packs$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){
        
        
      }
    });

    this.opened$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){
        this.startPackOpen();
      }
      this.isLoading=false;
    });
    
    
  }

  selectItem(deet){
    this.selected = deet.Id;
    this.mainfacade.selectPack(deet);
  }

  async startPackOpen(){
    
    this.allowVid=true;
    this.allowImg=false;
    this.showOpen = true;
    await this.startTimer(1);
    let packvid = document.getElementById('packvid') as HTMLVideoElement;
    packvid.classList.remove('hidepack');
    //packvid.classList.remove('hidden');
    this.allowImg=true;
    await this.startTimer(4.5);
    packvid.classList.add('hidepack');
 
    /*let loop= 100;
    let imgLoop= 0;
    while(loop>0){
      let start = Number(loop);
      let end = Number(loop-10);
      let startImg = Number(imgLoop);
      let endImg = Number(imgLoop+10);
      packvid.classList.add('opacity-'+(end/100));
      packvid.classList.remove('opacity-'+(start/100));
      //cardImg.classList.add('opacity-'+(endImg/100));
      //cardImg.classList.remove('opacity-'+(startImg/100));
    
      loop-=10;
      imgLoop+=10;
      await this.startTimer(1);
    }*/
    //packvid.classList.add('hidden');
    await this.startTimer(4);
    this.allowVid=false;
  }

  async startTimer(seconds:number){
    let mili = seconds * 1000;
    if(mili > 0){
      await this.delay(mili);
    }
    
  }

  openPack(id){
    this.isLoading=true;
    this.mainfacade.packOpen(this.user.Id, id, this.user.Wallet);
  }

  delay(t) {
    return new Promise(resolve => setTimeout(resolve, t))
  }

  closeOpen(){
    this.showOpen=false;
    this.mainfacade.closeOpen();
  }

}
